var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SwapInput',_vm._g(_vm._b({attrs:{"value":_vm.value,"label":_vm.label,"description":_vm.description,"dropdown":_vm.htmlDropdown.length > 0 ? _vm.htmlDropdown : null,"validation":_vm.validation,"error-text":_vm.errorText,"is-loading":_vm.isSearching},on:{"dropdownClick":_vm.dropdownClick}},'SwapInput',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }